import React, { useEffect, useState } from 'react';
import { useMutation, gql } from '@apollo/client';

const INSERT_PERSONAL_FISCALIA = gql`
  mutation InsertPersonalFiscalia($object: personal_fiscalia_insert_input!) {
    insert_personal_fiscalia_one(object: $object) {
      id
      nombre_completo
    }
  }
`;

const UPDATE_PERSONAL_FISCALIA = gql`
  mutation UpdatePersonalFiscalia($id: uuid!, $object: personal_fiscalia_set_input!) {
    update_personal_fiscalia_by_pk(pk_columns: { id: $id }, _set: $object) {
      id
      nombre_completo
    }
  }
`;

const RegistrarEmpleado = ({ empleado, onAgregarEmpleado, onVolver }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    cedula: '',
    nacimiento: '',
    cargo: '',
    ubicacion: '',
    telefono: '',
    email: '',
    grado: '',
    componente: '',
    tipo_personal: 'CIVIL',
  });

  const [insertPersonalFiscalia, { loading, error }] = useMutation(INSERT_PERSONAL_FISCALIA);
  const [updatePersonalFiscalia, { loading: updating }] = useMutation(UPDATE_PERSONAL_FISCALIA);

  const isEdit = Boolean(empleado?.id);

  const cargosDisponibles = [
    "Fiscal General Militar", "Fiscal General Adjunto", "Fiscal Superior", 
    "Fiscal Auxiliar", "Secretario", "Asistente Administrativo", 
    "Analista de Sistemas", "Seguridad", "Mensajero", "Otro"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (!empleado) return;
    setFormData({
      nombre: empleado.nombre_completo || '',
      cedula: empleado.cedula || '',
      nacimiento: empleado.fecha_nacimiento || '',
      cargo: empleado.cargo || '',
      ubicacion: empleado.ubicacion || '',
      telefono: empleado.telefono || '',
      email: empleado.email || '',
      grado: empleado.grado || '',
      componente: empleado.componente || '',
      tipo_personal: empleado.tipo_personal || 'CIVIL',
    });
  }, [empleado]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      nombre_completo: formData.nombre.trim().toUpperCase(),
      cedula: formData.cedula.replace(/\./g, '').trim(),
      fecha_nacimiento: formData.nacimiento,
      cargo: formData.cargo,
      ubicacion: formData.ubicacion.trim().toUpperCase(),
      telefono: formData.telefono.trim() || null,
      email: formData.email.trim() || null,
      tipo_personal: formData.tipo_personal, 
      grado: formData.tipo_personal === 'MILITAR' ? formData.grado : null,
      componente: formData.tipo_personal === 'MILITAR' ? formData.componente : null,
    };

    try {
      if (isEdit) {
        await updatePersonalFiscalia({
          variables: { id: empleado.id, object: dataToSend },
        });
        alert('¡Personal actualizado con éxito!');
      } else {
        await insertPersonalFiscalia({ variables: { object: dataToSend } });
        alert('¡Personal registrado con éxito!');
      }
      onAgregarEmpleado();
    } catch (err) {
      console.error("Error al insertar:", err);
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <div className="bg-white min-vh-100 pb-5">
      <div 
        className="bg-success text-white py-4 shadow-sm mb-4 d-flex align-items-center px-3"
        onClick={onVolver}
        style={{cursor: 'pointer'}}
      >
        <i className="bi bi-arrow-left fs-2 me-3"></i>
        <h4 className="mb-0 fw-bold">{isEdit ? 'Editar Personal' : 'Nuevo Registro'}</h4>
      </div>

      <div className="container" style={{maxWidth: '800px'}}>
        <form onSubmit={handleSubmit} className="px-3">
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label text-muted small fw-bold">DATOS DE IDENTIDAD</label>
              <input type="text" className="form-control mb-2" name="nombre" placeholder="Nombres y Apellidos" value={formData.nombre} onChange={handleChange} required />
              <div className="row g-2">
                <div className="col-6">
                  <input type="text" className="form-control" name="cedula" placeholder="V-12345678" value={formData.cedula} onChange={handleChange} required />
                </div>
                <div className="col-6">
                  <input type="date" className="form-control" name="nacimiento" value={formData.nacimiento} onChange={handleChange} required />
                </div>
              </div>
            </div>

            <div className="col-12 mt-4">
              <label className="form-label text-muted small fw-bold">CONTACTO</label>
              <div className="row g-2">
                <div className="col-6">
                  <input type="tel" className="form-control" name="telefono" placeholder="Teléfono" value={formData.telefono} onChange={handleChange} />
                </div>
                <div className="col-6">
                  <input type="email" className="form-control" name="email" placeholder="Correo Electrónico" value={formData.email} onChange={handleChange} />
                </div>
              </div>
            </div>

            <div className="col-12 mt-4">
              <label className="form-label text-muted small fw-bold">CLASIFICACIÓN Y CARGO</label>
              <select className="form-select mb-2" name="tipo_personal" value={formData.tipo_personal} onChange={handleChange}>
                <option value="CIVIL">Personal Civil</option>
                <option value="MILITAR">Personal Militar</option>
              </select>
              
              {formData.tipo_personal === 'MILITAR' && (
                <div className="row g-2 mb-2">
                  <div className="col-6"><input type="text" className="form-control" name="grado" placeholder="Grado" value={formData.grado} onChange={handleChange} /></div>
                  <div className="col-6"><input type="text" className="form-control" name="componente" placeholder="Componente" value={formData.componente} onChange={handleChange} /></div>
                </div>
              )}

              <select className="form-select mb-2" name="cargo" value={formData.cargo} onChange={handleChange} required>
                <option value="">Seleccione un Cargo...</option>
                {cargosDisponibles.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
              <input type="text" className="form-control" name="ubicacion" placeholder="Ubicación / Dependencia" value={formData.ubicacion} onChange={handleChange} />
            </div>

            <div className="col-12 mt-5">
              <button type="submit" className="btn btn-success w-100 py-3 fw-bold shadow" disabled={loading || updating}>
                {(loading || updating) ? 'PROCESANDO...' : (isEdit ? 'GUARDAR CAMBIOS' : 'GUARDAR PERSONAL')}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrarEmpleado;
